module.exports = __webpack_public_path__ + "static/media/carta_71.afa9f24e.jpg";